module.exports = __webpack_public_path__ + "img/dbyloi-no-strap.90e9e894.svg";